module.exports = __webpack_public_path__ + "img/1315137667.999af0ae.jpg";